var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-footer-flex-container"},[_c('TopNavBar'),_c('b-container',{staticClass:"is-footer-flex-content"},[_c('b-row',[_c('b-col',{staticClass:"mt-5",attrs:{"cols":"12","offset":"0","md":"8","offset-md":"2"}},[_c('LoginCard',{attrs:{"redirect":true}})],1)],1)],1),_c('BottomFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }